module.exports = __webpack_public_path__ + "img/btn_search.f5de4c2d.svg";